import { useContext } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { apiPost } from 'api'
import AuthContext from 'context/auth-context'

const provisionAws = async (token, municipalityId) => {
  const url = `admin/municipalities/${municipalityId}/aws_provisioning`
  return apiPost({ url, token, objectName: 'aws_provisioning', params: {} })
}

export function useProvisionMunicipalityAws({ municipalityId, options } = {}) {
  const token = useContext(AuthContext)
  const queryClient = useQueryClient()

  return useMutation(() => provisionAws(token, municipalityId), {
    ...options,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['admin-municipality', municipalityId])
      if (options?.onSuccess) options.onSuccess(data)
    }
  })
}
